class PaymentOptions extends HTMLElement {
  connectedCallback() {
    this.openButton = this.querySelector('[data-payment-open]');
    this.dialog = this.querySelector('[data-payment-dialog]');
    this.closeButton = this.querySelector('[data-payment-close]');
    this.tabButtons = [...this.querySelectorAll('[data-payment-tab]')];
    this.panels = [...this.querySelectorAll('[data-payment-panel]')];

    if (!this.dialog) return;

    this.openButton?.addEventListener('click', this.open);
    this.closeButton?.addEventListener('click', this.close);
    this.dialog.addEventListener('click', this.onDialogClick);
    this.dialog.addEventListener('close', this.onDialogClose);
    this.tabButtons.forEach((button) => button.addEventListener('click', this.onTabClick));
  }

  disconnectedCallback() {
    this.openButton?.removeEventListener('click', this.open);
    this.closeButton?.removeEventListener('click', this.close);
    this.dialog?.removeEventListener('click', this.onDialogClick);
    this.dialog?.removeEventListener('close', this.onDialogClose);
    this.tabButtons?.forEach((button) => button.removeEventListener('click', this.onTabClick));
    this.syncBodyState();
  }

  open = () => {
    if (!this.dialog?.open) this.dialog.showModal();
    document.body.classList.add('payment-options-open');
  };

  close = () => {
    if (this.dialog?.open) this.dialog.close();
  };

  onDialogClick = (event) => {
    if (event.target === this.dialog) this.close();
  };

  onDialogClose = () => {
    this.syncBodyState();
  };

  onTabClick = (event) => {
    const button = event.currentTarget;
    const key = button.dataset.paymentTab;
    if (!key) return;

    this.tabButtons.forEach((tab) => {
      const active = tab === button;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      const active = panel.dataset.paymentPanel === key;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
  };

  syncBodyState() {
    const hasOpenDialog = document.querySelector('payment-options dialog[open]');
    document.body.classList.toggle('payment-options-open', Boolean(hasOpenDialog));
  }
}

if (!customElements.get('payment-options')) {
  customElements.define('payment-options', PaymentOptions);
}
